import { Type } from "@scalar/typebox";
import { ServerObjectSchema } from "../../schemas/v3.1/strict/openapi-document.js";
const SettingsSchema = Type.Partial(
  Type.Object({
    proxyUrl: Type.String(),
    searchKey: Type.String(),
    /** Array of server configurations */
    servers: Type.Array(ServerObjectSchema),
    /** Base server URL for API requests */
    baseServerUrl: Type.String()
  })
);
const defaultSettings = {
  proxyUrl: "https://proxy.scalar.com",
  searchKey: "k",
  servers: [],
  baseServerUrl: ""
};
export {
  SettingsSchema,
  defaultSettings
};
//# sourceMappingURL=settings.js.map
